export const ROLE_ID_ADMIN_ROOT = 'root';
export const ROLE_ID_ADMIN = 'admin';
export const ROLE_ID_ADMIN_WHOLESALER = 'wholesaler';
export const ROLE_ID_PH = 'seller';
export const ROLE_ID_PH_REG = 'seller_reg';
